module.exports = __webpack_public_path__ + "img/ff-standard-logotype-gradient-480px.1fd5ee08.png";